export const DEEP_RESEARCH_IMG_LINK =
  'https://tii.imgix.net/global/homepage/ai_research_promo_v2.png';
export const PRO_OFFERING_IMG_LINK = 'https://tii.imgix.net/global/onboarding/pro_offering.png';
